import type { DomainKey } from "@/lib/domain"

// Este módulo é importado por client components (AeronaveCard, AeronaveGallery…).
// NÃO importar de ./r2 aqui — arrastaria o @aws-sdk/client-s3 para o bundle
// público. A URL pública só precisa de NEXT_PUBLIC_R2_PUBLIC_URL (inlinada no
// client pelo Next), então a computamos localmente.
const R2_PUBLIC_URL = process.env.NEXT_PUBLIC_R2_PUBLIC_URL ?? ""

export function buildPublicUrl(
  path: string | null | undefined,
): string | null {
  if (!path) return null
  return `${R2_PUBLIC_URL}/${path}`
}

/**
 * Caminho R2 da variante COM marca d'água, derivado deterministicamente do
 * storage_path original. Ex.: `abc/uuid.webp` → `abc/uuid.wm-aviadores.webp`.
 * Sem coluna nova no banco — pura transformação de string.
 */
export function watermarkedPath(path: string, brand: DomainKey): string {
  const base = path.replace(/\.(webp|jpe?g|png)$/i, "")
  return `${base}.wm-${brand}.webp`
}

/**
 * URL pública (CDN R2, servida direta — sem proxy serverless) da foto JÁ com
 * marca d'água embutida nos bytes. As variantes são pré-geradas no upload
 * (app/api/upload) e pelo scripts/backfill-watermarks.
 */
export function buildWatermarkedUrl(
  path: string | null | undefined,
  brand: DomainKey,
): string | null {
  if (!path) return null
  return buildPublicUrl(watermarkedPath(path, brand))
}
